import { Box, Button, Typography } from '@mui/material';
import { DiscoveryPaperCard } from '../../discovery';
import { errorCardActionsSx, errorCardContainerSx } from './styles';

type ErrorCardProps = {
  title: string;
  description: string;
  onCancel: () => void;
  onRetry: () => void;
};

export const ErrorCard = ({
  title,
  description,
  onCancel,
  onRetry,
}: ErrorCardProps) => (
  <DiscoveryPaperCard
    sx={{
      width: '100%',
      maxWidth: '644px',
      minHeight: '346px',
      alignItems: 'stretch',
      justifyContent: 'center',
      alignSelf: 'center',
    }}
  >
    <Box sx={errorCardContainerSx}>
      <Box>
        <Typography
          variant="h6"
          sx={{
            color: 'var(--text-primary, rgba(0, 0, 0, 0.87))',
            textAlign: 'center',
            fontFamily: 'var(--fontFamily, "Helvetica Neue")',
            fontSize: 'var(--font-size-125-rem, 20px)',
            fontStyle: 'normal',
            fontWeight: 'var(--fontWeightMedium, 500)',
            lineHeight: '160%',
            letterSpacing: '0.15px',
            fontFeatureSettings: '"liga" off, "clig" off',
            mb: '0px',
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'var(--text-secondary, rgba(0, 0, 0, 0.60))',
            textAlign: 'center',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontFamily: 'var(--fontFamily, "Helvetica Neue")',
            fontSize: 'var(--_fontSize-1rem, 16px)',
            fontStyle: 'normal',
            fontWeight: 'var(--fontWeightRegular, 400)',
            lineHeight: '150%',
            letterSpacing: '0.15px',
            mb: '0px',
          }}
        >
          {description}
        </Typography>
      </Box>
      <Box sx={errorCardActionsSx}>
        <Button variant="outlined" sx={{ textTransform: 'capitalize' }} onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" sx={{ textTransform: 'capitalize' }} onClick={onRetry}>
          Try Again
        </Button>
      </Box>
    </Box>
  </DiscoveryPaperCard>
);
